<div>
    <div class="modal-header d-flex justify-content-center"
        [ngClass]="modalType == 'error' ? 'error' : modalType == 'warning' ? 'warning' : 'success'">
        <h4 class="modal-title">{{'REJECT_USER_TITLE_TEXT' | translate}}</h4>
    </div>
    <div class="modal-body text-center">
        {{'REJECT_USER_CONFIRM_TEXT' | translate}}
        <div class="form-group">
          <div class="p-bottom-10">
            <label>{{'REJECT_USER_REASON_TEXT' | translate}}:</label>
          </div>
          <textarea class="form-control" rows="3" #rejectJustification
              [attr.maxLength]="maxReasonLength" (input)="currentLength = rejectJustification.value.length"></textarea>
          <div class="text-end small mt-1"
              [ngClass]="{'text-danger': currentLength > maxReasonLength}">
              {{currentLength}} / {{maxReasonLength}}
          </div>
          <div class="error-msg text-align" *ngIf="displayErrorMsgBlock && currentLength === 0">
                  {{'REJECT_REASON_EMPTY_ERROR' | translate}}
          </div>
        </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
        <button class="btn btn-primary btn-block primary-btn" (click)="confirmUserRejection()">{{'REJECT_USER_TEXT' | translate}}</button>
        <button class="btn white-bg sec-button" (click)="cancelUserRejection()">{{'CANCEL' | translate}}</button>
    </div>
</div>